import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { focusAfterTimeout, organizationGoalsAreDirty, generateUnsafeHash } from '../../util';

import { getDefaultOrganizationGoals } from '../../util/data';

import { updateGoals, endEditingGoals } from '../../actions/goals';

import Switch from 'react-switch';

const BLANK_RATINGS = ['','','','','','','','','',''];

const DEFAULT_CREATE_NEW_GOAL_PROPS = {
  creatingNewGoal: false,
  newGoalName: '',
  newGoalDescription: '',
  newGoalDefinition: '',
  newGoalRatings: BLANK_RATINGS
}

class UpdateGoalsModal extends Component{

  state = {
    goals: [],
    activeTab: 'behavior',
    editingGoal: null,
    editingGoalNewDefinition: '',
    ...DEFAULT_CREATE_NEW_GOAL_PROPS
  }

  activateTab(tabName){
    this.setState({
      ...DEFAULT_CREATE_NEW_GOAL_PROPS,
      editingGoal: null,
      activeTab: tabName
    });
  }

  componentWillReceiveProps(nextProps){

    const { editingGoal } = this.props;

    if(editingGoal && !nextProps.syncingWithServer){
      this.setState({
        editingGoal,
        editingGoalNewDefinition: editingGoal.definition || '',
        editingGoalNewRatings: editingGoal.ratings || BLANK_RATINGS,
        activeTab: editingGoal.category,
      });

      focusAfterTimeout(this, 'editGoalDefinitionInput');
    }
    else{
      this.setState({
        editingGoal: null,
        editingGoalNewDefinition: '',
        editingGoalNewRatings: BLANK_RATINGS
      });
    }

    //reset local copy of goals if we receive new goals data from props
    if(nextProps.data && !nextProps.syncingWithServer){
      this.setState({
        goals: nextProps.data
      });
    }
  }

  editGoal(goal){
    this.setState({
      editingGoal: goal,
      editingGoalNewDefinition: goal.definition,
      editingGoalNewRatings: goal.ratings
    });
  }

  goalsAreDirty(){
    const goalsInState = this.state.goals;
    const goalsFromProps = this.props.data;

    console.log(goalsInState);
    console.log(goalsFromProps);
    console.log('organizationGoalsAreDirty: ', organizationGoalsAreDirty(goalsInState, goalsFromProps));

    return organizationGoalsAreDirty(goalsInState, goalsFromProps);
  }

  getSaveButtonText(){
    const { syncingWithServer } = this.props;

    if(syncingWithServer){
      return 'Saving...';
    }
    else{
      return 'Save changes';
    }
  }

  allGoals(){
    return this.state.goals;
  }
  goalsForActiveTab(){
    return _.filter(this.allGoals(), goal => {
      return goal.category === this.state.activeTab
    });
  }
  newGoalTypeForActiveTab(){
    switch(this.state.activeTab){
      default:
      case 'behavior':
      case 'skill':
        return 'do';
      case 'activity':
        return 'measure';
      case 'outcome':
        return 'forecast';
    }
  }

  activateGoal(goalToActivate){
    const { goals } = this.state;

    let updatedGoals = _.cloneDeep(goals);

    _.each(updatedGoals, goal => {
      if(goal.id === goalToActivate.id){
        delete goal.inactive;
      }
    });

    this.setState({
      goals: updatedGoals
    });
  }
  inactivateGoal(goalToInactivate){
    const { goals } = this.state;

    let updatedGoals = _.cloneDeep(goals);

    _.each(updatedGoals, goal => {
      if(goal.id === goalToInactivate.id){
        goal.inactive = true;
      }
    });

    this.setState({
      goals: updatedGoals
    });
  }

  toggleGoal(goal, active){
    if(active){
      this.activateGoal(goal);
    }
    else{
      this.inactivateGoal(goal);
    }
  }

  undoChanges(){
    this.setState({
      goals: this.props.data
    });
  }

  updateGoals(){
    this.props.updateGoals(this.state.goals, updatedGoals => {
      this.props.onSave();
    });
  }

  updateNewGoalName(name){
    this.setState({
      newGoalName: name
    });
  }
  updateNewGoalDescription(description){
    this.setState({
      newGoalDescription: description
    });
  }
  updateNewGoalDefinition(definition){
    this.setState({
      newGoalDefinition: definition
    });
  }
  updateNewGoalRating(ratingIndex, newRatingValue){

    let updatedRatings = [...this.state.newGoalRatings];

    updatedRatings[ratingIndex] = newRatingValue;

    this.setState({
      newGoalRatings: updatedRatings
    });
  }

  creatNewGoal(){
    let newGoalData = {
      name: this.state.newGoalName,
      description: this.state.newGoalDescription,
      category: this.state.activeTab,
      id: generateUnsafeHash(),
      goalType: this.newGoalTypeForActiveTab(),
    }

    if(this.state.newGoalDefinition && this.state.newGoalDefinition !== ''){
      newGoalData.definition = this.state.newGoalDefinition;
    }

    this.setState({
      goals: [
        ...this.state.goals,
        newGoalData
      ],
      ...DEFAULT_CREATE_NEW_GOAL_PROPS
    });
  }
  cancelNewGoal(){
    this.setState(DEFAULT_CREATE_NEW_GOAL_PROPS);
  }

  beginCreatingNewGoal(){
    this.setState({
      creatingNewGoal: true
    }, () => {

      focusAfterTimeout(this, 'newGoalNameInput');
    });
  }

  renderCreateNewGoalButton(){

    const { newGoalName, newGoalDescription } = this.state;

    return (
      <li key="create-new-goal-button" className="item new" onClick={this.beginCreatingNewGoal.bind(this)}>
        <div className="item-name">New</div>
        <div className="item-description">Create new {this.state.activeTab} goal...</div>
      </li>
    )
  }

  renderNewGoalRatings(){

    const goalRatings = this.state.newGoalRatings;

    return(
      <div className="goal-ratings">
        <label>Goal Ratings</label>
        {_.map([1,2,3,4,5,6,7,8,9,10], num => {
          return <input onChange={(e) => { this.updateNewGoalRating(num - 1, e.target.value); }} key={'input-for-' + num} type="text" placeholder={`${num} Star Definition`} value={goalRatings[num - 1] || ''} />
        })}

      </div>
    );
  }
  renderEditGoalRatings(){
    const goalRatings =  this.state.editingGoalNewRatings;

    return(
      <div className="goal-ratings">
        <label>Goal Ratings</label>
        {_.map([1,2,3,4,5,6,7,8,9,10], num => {
          return <input onChange={(e) => { this.updateEditingGoalRating(num - 1, e.target.value); }} key={'input-for-' + num} type="text" placeholder={`${num} Star Definition`} value={goalRatings[num - 1] || ''} />
        })}

      </div>
    );
  }

  renderCreateNewGoalForm(){

    const { newGoalName, newGoalDescription, newGoalDefinition } = this.state;

    const newGoalType = this.state.activeTab;
    const newGoalTypeString = newGoalType.slice(0,1).toUpperCase() + newGoalType.slice(1);
    const goalRequiresTalentCardDefinition = newGoalType === 'behavior' || newGoalType === 'skill';

    return (
      <li key="create-new-goal-form" className="item create">
        <input ref={input => { this.newGoalNameInput = input; }} className="item-name-input" type="text" onChange={e => { this.updateNewGoalName(e.target.value); }} value={newGoalName} placeholder={newGoalTypeString + ' name'} />
        <input className="item-description-input" type="text" onChange={e => { this.updateNewGoalDescription(e.target.value); }} value={newGoalDescription} placeholder={newGoalTypeString + ' description'} />
        {goalRequiresTalentCardDefinition &&
          <textarea className="item-definition-input" onChange={e => { this.updateNewGoalDefinition(e.target.value); }} value={newGoalDefinition} placeholder={newGoalTypeString + ' definition for talent card survey'} />
        }
        {goalRequiresTalentCardDefinition && this.renderNewGoalRatings()}
        <button onClick={this.cancelNewGoal.bind(this)} className="button grey-outline button-sm">Cancel</button>
        <button disabled={newGoalName === '' || newGoalDescription === ''} onClick={this.creatNewGoal.bind(this)} className="button primary button-sm">Add goal</button>
      </li>
    );
  }

  updateEditingGoalNewDefinition(definition){
    this.setState({
      editingGoalNewDefinition: definition
    });
  }
  updateEditingGoalRating(ratingIndex, newRatingValue){

    let updatedRatings = [...this.state.editingGoalNewRatings];

    updatedRatings[ratingIndex] = newRatingValue;

    this.setState({
      editingGoalNewRatings: updatedRatings
    });
  }

  cancelEditGoal(){
    this.setState({
      editingGoal: null,
      editingGoalNewDefinition: ''
    });
  }

  saveEditingGoal(){

    let updatedGoals = [...this.state.goals];

    const editingGoal = this.state.editingGoal;

    const matchingGoalIndex = _.findIndex(this.state.goals, goal => {
      return goal.id === editingGoal.id;
    });

    //update if matching
    if(matchingGoalIndex !== -1){

      updatedGoals[matchingGoalIndex] = {
        ...editingGoal,
        definition: this.state.editingGoalNewDefinition,
        ratings: this.state.editingGoalNewRatings,
      }
    }

    //save changes to state
    this.setState({
      goals: updatedGoals,
      editingGoal: null,
      editingGoalNewDefinition: '',
      editingGoalNewRatings: BLANK_RATINGS
    });
  }

  editGoal(goal){

    this.setState({
      editingGoal: goal,
      editingGoalNewDefinition: goal.definition || '',
      editingGoalNewRatings: goal.ratings || BLANK_RATINGS,
    });

    focusAfterTimeout(this, 'editGoalDefinitionInput');

    setTimeout(() => {
      const goalsForTab = document.getElementById('goals-for-tab');
      goalsForTab.scrollTop = goalsForTab.offsetHeight + 300;//idk why +300 is needed
    }, 50);
  }

  renderEditGoalForm(){
    const { editingGoal, editingGoalNewDefinition, editingGoalNewRatings } = this.state;

    if(!editingGoal){
      return null;
    }

    const goalCategory = editingGoal.category;
    const goalCategoryString = goalCategory.slice(0,1).toUpperCase() + goalCategory.slice(1);
    const goalRequiresTalentCardDefinition = goalCategory === 'behavior' || goalCategory === 'skill';

    console.log('comparing: ', editingGoalNewRatings);
    console.log('with: ', editingGoal.ratings);
    console.log(_.isEqual(editingGoalNewRatings, editingGoal.ratings));

    return (
      <li key="edit-goal-form" className="item edit">
        <input disabled={true} value={editingGoal.name} className="item-name-input" type="text" />
        <input disabled={true} value={editingGoal.description} className="item-description-input" type="text" />
        {goalRequiresTalentCardDefinition &&
          <textarea ref={input => { this.editGoalDefinitionInput = input; }} className="item-definition-input" onChange={e => { this.updateEditingGoalNewDefinition(e.target.value); }} value={editingGoalNewDefinition} placeholder={editingGoal.name + ' definition for talent card survey'} />
        }
        {goalRequiresTalentCardDefinition && this.renderEditGoalRatings()}
        <button onClick={this.cancelEditGoal.bind(this)} className="button grey-outline button-sm">Cancel</button>
        <button disabled={editingGoalNewDefinition === editingGoal.definition && _.isEqual(editingGoalNewRatings, editingGoal.ratings)} onClick={this.saveEditingGoal.bind(this)} className="button primary button-sm">Done</button>
      </li>
    )
  }

  addDefaultGoalsForActiveTab(){

    const goalsToAdd = getDefaultOrganizationGoals()[this.state.activeTab];

    this.setState({
      goals: [
        ...this.state.goals,
        ...goalsToAdd
      ]
    });
  }

  renderAddGoalsFromVelocityDefaultsButton(){

    const activeTab = this.state.activeTab;

    return (
      <div className="add-default-goals">
        <p>Start adding your own custom goals, or click the button below to add an initial set of goals recommended by the Velocity Team.</p>
        <button onClick={this.addDefaultGoalsForActiveTab.bind(this)} className="button primary">Add default {activeTab} goals</button>
      </div>
    );
  }

  renderGoalsForActiveTab(){

    const { creatingNewGoal, editingGoal } = this.state;

    return(
      <template>
        {this.goalsForActiveTab().length === 0 && this.renderAddGoalsFromVelocityDefaultsButton()}
        <div id="goals-for-tab" className="goals-for-tab">
          {_.map(this.goalsForActiveTab(), goal => {

            if(editingGoal || creatingNewGoal){
              return null;
            }

            const goalRequiresTalentCardDefinition = goal.category === 'behavior' || goal.category === 'skill';

            return <div className={'item' + (!goal.inactive ? ' active' : '')} key={goal.id}>
              <div className="item-name">{goal.name}</div>
              <div className="item-description">{goal.description}</div>
              {goal.definition && goal.definition !== '' &&
                <div className="item-definition">{goal.definition}</div>
              }
              <div className="item-switch">
                <Switch
                  id="some-switch"
                  checked={!goal.inactive}
                  onChange={checked => { this.toggleGoal(goal, checked); } }
                  handleDiameter={20}
                  offColor="#D2D2D2"
                  onColor="#2D9542"
                  offHandleColor="#545B72"
                  onHandleColor="#FFFFFF"
                  height={28}
                  width={60}
                  className="react-switch-input"
                />
              </div>
              {!goal.inactive && goalRequiresTalentCardDefinition && goal.definition &&
                <button onClick={() => { this.editGoal(goal); } } className="goal-definition-action button grey-button button-micro">Update definition</button>
              }
              {!goal.inactive && goalRequiresTalentCardDefinition && !goal.definition &&
                <button onClick={() => { this.editGoal(goal); } } className="goal-definition-action button primary button-micro">Add talent card definition</button>
              }
            </div>
          })}

          {!editingGoal && !creatingNewGoal && this.renderCreateNewGoalButton()}
          {!editingGoal && creatingNewGoal && this.renderCreateNewGoalForm()}
          {this.renderEditGoalForm()}
        </div>
        <div className="goals-for-tab-scroll-indicator"></div>
      </template>
    );
  }

  render(){

    if(!this.props.editing){
      return null;
    }

    const { syncingWithServer, editing, error, message } = this.props;

    const { activeTab } = this.state;

    return (
      <div className="modal update-goals">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.endEditingGoals}>X</div>
          <div className="modal-content">
            <div className="velocity-form">
              <div className="form-tabs">
                <div onClick={() => { this.activateTab('behavior'); }} className={'tab' + (activeTab === 'behavior' ? ' active' : '')}>Behaviors</div>
                <div onClick={() => { this.activateTab('skill'); }} className={'tab' + (activeTab === 'skill' ? ' active' : '')}>Skills</div>
                <div onClick={() => { this.activateTab('activity'); }} className={'tab' + (activeTab === 'activity' ? ' active' : '')}>Activities</div>
                <div onClick={() => { this.activateTab('outcome'); }} className={'tab' + (activeTab === 'outcome' ? ' active' : '')}>Outcomes</div>
              </div>

              {this.renderGoalsForActiveTab()}
            </div>
          </div>
          <div className="modal-actions">
            {!this.goalsAreDirty() && !syncingWithServer &&
              <button className="button primary" onClick={this.props.endEditingGoals}>Done</button>
            }
            {(this.goalsAreDirty() || syncingWithServer) &&
              <template>
                <button className="button primary" onClick={this.updateGoals.bind(this)} disabled={syncingWithServer}>{this.getSaveButtonText()}</button>
                {!syncingWithServer &&
                  <button className="button grey-button" onClick={this.props.endEditingGoals}>Cancel</button>
                }
                <button className="button transparent-button sm secondary" onClick={this.undoChanges.bind(this)}>Undo changes</button>
              </template>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    ...state.editingGoals
  };
}

export default connect(mapStateToProps, { updateGoals, endEditingGoals })(UpdateGoalsModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateGoals.js